import React from "react";
import { render } from "react-dom";
import HasuraGraphiQL from "@hasura/public-graphiql";
import { getPresets } from "./utils";
import "./index.css";
import "@hasura/public-graphiql/dist/tailwind-override.css";
import Spinner from "./Spinner";
import { useCloudCheck } from "./useCloudCheck";
import { useRemoteQuery } from "./useRemoteQuery";
import LandingPage from "./LandingPage";
import Banner from "./Banner";

const container = document.getElementById("root");

function App() {
  const {
    defaultHeaders,
    defaultQuery,
    defaultUrl,
    defaultVariables,
    queryFile,
  } = getPresets();
  const [endpoint, setEndpoint] = React.useState(defaultUrl);
  const { cloudCheck, isHasuraCloud } = useCloudCheck(endpoint);
  const { remoteQueryChecked, remoteQuery } = useRemoteQuery(queryFile);

  if (endpoint.length) {
    if (cloudCheck === "done" && remoteQueryChecked)
      return (
        <>
          <Banner authBase={(window as any).__envAuthBase} />
          <div className="graphiql-holder">
            <HasuraGraphiQL
              url={endpoint}
              defaultHeaders={defaultHeaders}
              defaultQuery={remoteQuery || defaultQuery}
              defaultVariables={defaultVariables}
              isCloud={isHasuraCloud}
              customToolbar={
                <button
                  onClick={() => setEndpoint("")}
                  className="change-endpoint-button"
                >
                  Change Endpoint
                </button>
              }
            />
          </div>
        </>
      );
    return <Spinner />;
  }

  return <LandingPage url={endpoint} setEndpoint={setEndpoint} />;
}

render(<App />, container);
